import InvoiceCreate from "../pages/Invoice/Create";
// import Invoice from "../pages/Invoice/Report";
import InvoiceReportNew from "../pages/Invoice/Report";
import JobIndex from "../pages/Job-new/Index";
import CustomerIndex from "../pages/masters/customer";
import ReceivableReport from "../pages/masters/customer/Receivable";
import JobTypeIndex from "../pages/masters/job-type/Index";
import LedgerIndex from "../pages/masters/ledger/Index";
import JobCharges from "../pages/masters/job-charges/index";
import PaymentModeIndex from "../pages/masters/payment-mode/Index";
import SupplierIndex from "../pages/masters/supplier/Index";
import SupplierInvoice from "../pages/masters/supplier/SupplierInvoice";
import PayableReport from "../pages/masters/supplier/Payable";
import Statement from "../pages/vouchers/Statement";
import PaymentVoucherIndex from "../pages/vouchers/payment/Index";
import ReceiptVoucherIndex from "../pages/vouchers/receipt/Index";
import IncomeStatement from "../pages/reports/income-statement/index";
import LedgerVoucherIndex from "../pages/vouchers/ledger/index";
import DayBook from "../pages/reports/day-book/index";
import Profile from "../pages/Profile/Profile";
import ProfitLossIndex from "../pages/reports/profit_loss/Index";
import BalanceSheetIndex from "../pages/reports/balance_sheet/Index";
import JobAddForm from "../pages/Job-new/JobAddForm";

const AsitRoutesConfig = {
  router_asit: [
    {
      path: `${process.env.PUBLIC_URL}/job-type`,
      component: JobTypeIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/payment-mode`,
      component: PaymentModeIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/ledger`,
      component: LedgerIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/job-charges`,
      component: JobCharges,
    },
    {
      path: `${process.env.PUBLIC_URL}/supplier`,
      component: SupplierIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/supplier/invoice/report`,
      component: SupplierInvoice,
    },
    {
      path: `${process.env.PUBLIC_URL}/customer`,
      component: CustomerIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/voucher/payment`,
      component: PaymentVoucherIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/job`,
      component: JobIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/job/jobCreate`,
      component: JobAddForm,
    },
    {
      path: `${process.env.PUBLIC_URL}/voucher/receipt`,
      component: ReceiptVoucherIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/voucher/ledger`,
      component: LedgerVoucherIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/receivable`,
      component: ReceivableReport,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/payable`,
      component: PayableReport,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/incomeStatement`,
      component: IncomeStatement,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/dayBook`,
      component: DayBook,
    },
    {
      path: `${process.env.PUBLIC_URL}/:type/statement/:id`,
      component: Statement,
    },
    {
      path: `${process.env.PUBLIC_URL}/invoice/create`,
      component: InvoiceCreate,
    },
    {
      path: `${process.env.PUBLIC_URL}/profile`,
      component: Profile,
    },
    {
      path: `${process.env.PUBLIC_URL}/invoice/report`,
      component: InvoiceReportNew,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/profit-loss`,
      component: ProfitLossIndex,
    },
    {
      path: `${process.env.PUBLIC_URL}/report/balance-sheet`,
      component: BalanceSheetIndex,
    },
  ],
};

export default AsitRoutesConfig;
